// 线索清洗
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, FormGroup, RadioGroup } from '@tencent/spaui';
import MessageBox from '@/components/MessageBox';
import { withApi } from '@tencent/react-aio';
import * as ActionTypes from '@/stores/sale/actions';
import _ from 'lodash';
import Dialog from '@/components/Dialog';
import * as Constants from '@/constants/Constants';
import PotentialStatusSelect from '@/components/PotentialStatusSelect';
import LeadReasonSelect from '@/business-components/sale/LeadReasonSelect';
import { CLEANING_STATUS, toPotentialDefaultConfig } from '@/constants/Constants';
import classNames from 'classnames';
import PotentialReasonSelect from '@/business-components/sale/PotentialReasonSelect';
const config = _.filter(CLEANING_STATUS, d => !d.filter).map((v) => {
  return {
    value: v.value,
    children: v.label,
  };
});
const cleanStatusDes = _.keyBy(CLEANING_STATUS, 'value');
class CleanLeadModal extends React.Component {
  static propTypes = {
    leadId: PropTypes.number.isRequired,
    version: PropTypes.number.isRequired,
    companyName: PropTypes.string.isRequired,
    onSubmit: PropTypes.func,
  }

  state = {
    potentialStatus: toPotentialDefaultConfig.potentialStatus,
    transactionProbability: toPotentialDefaultConfig.transactionProbability,
    potentialSecondSeasonType: toPotentialDefaultConfig.potentialSecondSeasonType,
  }

  render() {
    const { companyName, reasonList = {} } = this.props;
    const { potentialStatus, transactionProbability, description, status, toPotentialDecision, submitting, reason, potentialSecondSeasonType } = this.state;
    const decisionConfig = [
      {
        value: Constants.OPTION_YES,
        children: '是',
      },
      {
        value: Constants.OPTION_NO,
        children: '否',
      },
    ];
    /* const temconfig = [{
       value: Constants.OPTION_INDUSTRY,
       children: '行业不准入'
     }, {
       value: Constants.OPTION_CONTACT,
       children: '联系不上'
     }, {
       value: Constants.OPTION_CUSTOMER,
       children: '客户非本人'
     }, {
       value: Constants.OPTION_INCOMPLETE,
       children: '资质不齐全'
     }];*/
    const Content = (props) => {
      const [inputValue, setInputValue] = useState(props.iptValue);

      return (
        <div>
          {/* <blockquote className="info">线索清洗后立即生效，清洗状态一经确认无法修改！</blockquote>*/}
          <div className="RadioGroup">
            <FormGroup className={'required'}>
              <label>请选择清洗结果：</label>
            </FormGroup>
            <RadioGroup data={config} value={status} onChange={this.handleChange} />
            {cleanStatusDes[status] && (
              <p className="clean-status-des">
                {cleanStatusDes[status].label}: {cleanStatusDes[status].des}
              </p>
            )}
            <br />
          </div>
          {reasonList[status] && reasonList[status].length > 0 ? (
            <div className="RadioGroup">
              <FormGroup className='required'>
                <label>请选择原因：</label>
                <LeadReasonSelect
                  props={{
                    unrelated: true,
                  }}
                  cleaningStatus={[status]}
                  value={reason}
                  onChange={this.handleReason}
                  onClear={(event, value) => {
                    this.handleReason(event, undefined);
                  }}
                />
                <br />
              </FormGroup>
            </div>
          ) : null}
          {status === config[0].value && (
            <React.Fragment>
              <p>
                <FormGroup className={'required'}>
                  <label>是否将此线索转为商机</label>
                </FormGroup>
              </p>
              <RadioGroup data={decisionConfig} value={toPotentialDecision} onChange={this.handleChangeToPotentialDecision} />
              <br />
              {toPotentialDecision === decisionConfig[0].value && (typeof toPotentialDecision === 'undefined' || toPotentialDecision === decisionConfig[0].value) && (
                <React.Fragment>
                  <FormGroup className={'with-select required'}>
                    <label htmlFor={'potentialStatus'}>商机状态：</label>
                    <PotentialStatusSelect usePotentialStatusNew id={'potentialStatus'} mode={'block'} potentialStatus={potentialStatus} transactionProbability={transactionProbability} onChange={this.handleChangePotentialStatus} />
                  </FormGroup>
                  {
                    potentialStatus && <FormGroup className={'with-select required'}>
                      <label htmlFor={'potentialStatus'}>意向原因：</label>
                      <PotentialReasonSelect potentialStatus={`${potentialStatus}-${transactionProbability}`} value={potentialSecondSeasonType} onChange={this.handlePotentialSecondSeasonType} />
                    </FormGroup>
                  }
                </React.Fragment>
              )}
            </React.Fragment>
          )}
          <FormGroup className={classNames({
            'with-textarea': true,
            required: true,
          })}>
            <label htmlFor={'description'}>跟进情况：</label>
            <textarea
              id={'description'}
              className="spaui-input"
              minLength={3}
              value={inputValue}
              onChange={(e) => {
                setInputValue(e.target.value);
              }}
              onBlur={() => {
                props.setIpt(inputValue);
              }}
            />
          </FormGroup>
          {/* {status === config[1].value && (
          <React.Fragment>
            <br/>
            <p><label>暂不合格的原因:</label></p>
            <RadioGroup
              data={temconfig}
              value={toPotentialDecision}
              onChange={this.handleChangeToPotentialDecision}
            />
          </React.Fragment>
        )}*/}
        </div>
      );
    };

    if (this.props.notDialog) {
      return (
        <div className="phone-follow-up-content CreateActionRecordModal">
          <h4>清洗线索</h4>
          <Content iptValue={description} setIpt={this.handleChangeDescription}/>
          <div className="phone-follow-up-content-confirm">
            <Button onClick={this.onSubmit}>确定</Button>
          </div>
        </div>
      );
    }

    return (
      <Dialog className="CreateActionRecordModal" title="清洗线索" subTitle={companyName} style={{ width: 640 }} {...this.props} onSubmit={this.onSubmit} disabled={submitting}>
        <Content iptValue={description} setIpt={this.handleChangeDescription}/>
      </Dialog>
    );
  }

  handleChange = (event, value) => {
    this.props.rerenderDialog?.();
    this.setState({
      status: value,
      toPotentialDecision: undefined,
      reason: null,
    });
  }

  handleReason = (e, reason) => {
    this.setState({
      reason,
      toPotentialDecision: undefined,
    });
  }

  handleChangeToPotentialDecision = (event, value) => {
    this.props.rerenderDialog?.();
    this.setState({
      toPotentialDecision: value,
    });
  }

  handleChangePotentialStatus = (e, value) => {
    const { potentialStatus, transactionProbability } = value;
    this.setState({
      potentialStatus,
      transactionProbability,
      potentialSecondSeasonType: undefined,
    });
  }

  handlePotentialSecondSeasonType = (e, potentialSecondSeasonType) => {
    this.setState({ potentialSecondSeasonType });
  }

  handleChangeDescription = (value) => {
    this.setState({
      description: value,
    });
  }

  onSubmit = () => {
    const { leadId, webApi, version, isOpenStateTag, reasonList } = this.props;
    const { toPotentialDecision, transactionProbability, potentialStatus, description, status, reason, potentialSecondSeasonType } = this.state;

    if (!status) {
      return;
    }

    if (!description) {
      return;
    }

    if (!reason) {
      return;
    }

    if (status === 'CLEANING_STATUS_VALID' && toPotentialDecision === undefined) {
      return;
    }
    let cleanLeadParam;
    let successMsg;
    if (!!toPotentialDecision && toPotentialDecision === Constants.OPTION_YES) {
      // 数据校验
      if (!potentialStatus || !description || !potentialSecondSeasonType) {
        return;
      }

      successMsg = '线索清洗成功并转为商机';

      cleanLeadParam = {
        cleaningStatus: status,
        toPotentialDecision,
        version,
        convertVo: {
          potentialStatus,
          transactionProbability,
          description,
          potentialSecondSeasonType,
        },
      };
    } else {
      successMsg = '线索清洗成功';

      cleanLeadParam = {
        cleaningStatus: status,
        toPotentialDecision,
        version,
      };
      // 如果有跟进记录，则拼接参数comments
      if (description) {
        cleanLeadParam.comments = description;
      }
    }

    // 原因配置开启
    if (isOpenStateTag && reasonList[status] && reasonList[status].length > 0) {
      if (reason) {
        cleanLeadParam.leadStateReasonTagId = reason;
      }
    }
    if (this.state.status) {
      // 提交
      this.setState({
        submitting: true,
      });
      webApi
        .cleanLead(leadId)
        .dispatchJson(ActionTypes.CLEAN_LEAD, {
          data: cleanLeadParam,
        })
        .then(
          (resp) => {
            this.setState({
              submitting: false,
            });
            if(resp.code === 0) {
                this.context.success(successMsg);
                this.props.onSubmit();
            }

            if(resp.code === 400) {
               this.context.error('清洗线索失败', resp.message);
               this.props.onSubmit();
            }
          },
          (error) => {
            this.setState({
              submitting: false,
            });
            this.context.error('清洗线索失败', error.message);
            this.props.onSubmit();
          },
        );
    }
  }

  // onCancel = () => {
  //   this.props.callback(null)
  // }
  //
  // onClose = () => {
  //   this.props.callback(null)
  // }
}

export default withApi(CleanLeadModal);

CleanLeadModal.contextType = MessageBox;
